import { Button } from '@/components/atoms/Button';
import { Box, List } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  overflowX: 'hidden',
  overflowY: 'auto',
}));

export const StyledList = styled(List)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  padding: 0,
  margin: `${theme.spacing(1)} 0`,
}));

export const UserButton = styled(Button)(({ theme }) => ({
  width: '100%',
  justifyContent: 'flex-start',
  gap: theme.spacing(2),
  padding: theme.spacing(1, 1.25),
  margin: theme.spacing(0.5, 0),
}));
